document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.header');
    const headerSixth = document.querySelector('.header-sixth');
    const firstSection = document.querySelector('section');
    const content = document.querySelector('.margin');
    const containers = document.querySelectorAll('.container');
    const main = document.querySelector('main');

    if (header) {
        function updateContentPadding() {
            const headerHeight = header.offsetHeight;
            const contentPaddingTop = headerHeight + 40;

            if (firstSection.classList.contains('not-found-section')) {
                firstSection.style.paddingTop = `${headerHeight + 10}px`;
            } else if (firstSection && !firstSection.classList.contains('banner') && !firstSection.classList.contains('not-found-section')) {
                main.style.paddingTop = `${contentPaddingTop}px`;
            }

            if (content && (header.classList.contains('header-first') || header.classList.contains('header-second') || header.classList.contains('header-sixth'))) {
                if (firstSection.classList.contains('banner')) {
                    content.style.paddingTop = `${contentPaddingTop}px`;
                }
            } else {
                if (firstSection.classList.contains('banner-second') || firstSection.classList.contains('banner-first')) {
                    const bannerHeight = window.innerHeight;
                    firstSection.style.height = `${bannerHeight - headerHeight}px`;
                    main.style.paddingTop = `${headerHeight}px`;
                } else if (firstSection.classList.contains('banner') && !firstSection.classList.contains('banner-second') && !firstSection.classList.contains('banner-first')) {
                    main.style.paddingTop = `${contentPaddingTop}px`;
                }
            }
        }

        updateContentPadding();
        if (!firstSection.classList.contains('banner-second') && !firstSection.classList.contains('banner-first')) {
            window.addEventListener('resize', updateContentPadding);
        }
    }

    if (headerSixth) {
        function updateContentPaddingLeft() {
            const MaxWidth = document.querySelector('.max-width');

            containers.forEach(container => {
                container.style.paddingLeft = '85px';
                if (MaxWidth) {
                    MaxWidth.style.paddingLeft = '65px';
                }
                if (window.innerWidth <= 480) {
                    container.style.paddingLeft = '15px';
                    if (MaxWidth) {
                        MaxWidth.style.paddingLeft = '0';
                    }
                }
            });
        }

        updateContentPaddingLeft();
        window.addEventListener("resize", updateContentPaddingLeft());
    }
});